module.exports = __webpack_public_path__ + "static/media/action1.cb78af11.png";